export const SETTING_OPTIONS = [
  {name: "Account Settings", id: 2},
  {name: "WFM Schedule", id: 3},
  // {name: "Help & Support", id: 4},
  {name: "Logout", id: 1} 
]